import React from 'react';
import Reconstruction from 'src/components/reconstruction/reconstruction';
import ReconstructionLayout from 'src/components/reconstruction/reconstruction-layout';


const ReconstructionPage: React.FC = () => {
  return (
    <ReconstructionLayout children={<Reconstruction/>}></ReconstructionLayout>
  );
};

export default ReconstructionPage;